export default __webpack_public_path__ + "static/media/finger_positions_DFJK_mobile.f557cc4e.png";